import Axios from 'axios'
import { SupplementalDocumentationDTO } from 'src/viewModels/workflow/SupplementalDocumentationDTO'

const base_url = process.env.REACT_APP_BASE_URL || 'http://localhost:5000'

// backend returns the raw PDF file (application/pdf), not a base64 JSON string
export async function previewSupplementalDocumentationPDF(
  type: string,
  supplimentalDocument: SupplementalDocumentationDTO
): Promise<ArrayBuffer> {
  const response = await Axios.post<ArrayBuffer>(
    `${base_url}/api/supplemental-documentation/${type}/preview-pdf`,
    supplimentalDocument,
    {
      responseType: 'arraybuffer',
    }
  )

  return response.data
}
